import { useContext } from 'react';
import { SchemaExpressionScopeContext } from '@formily/react';
export const useScope = () => {
    const appContext = useContext(window.__appContext);
    const expressionScope = useContext(SchemaExpressionScopeContext);
    return {
        $this: appContext?.pageContext,
        ...(expressionScope || {}),
    };
};
